import { components } from 'generated/payment-initialisation/schema';

import { IRemitterFormValues } from './RemitterDrawer';

const mapToRemitterCreateRequest = (values: IRemitterFormValues, entityId: string): components['schemas']['RemitterCreateRequest'] => ({
  EntityId: entityId,
  Payee: values.remitterName,
  PayeeCountryCode: values.country,
  Currency: values.currency,
  BankName: values.bankName,
  Iban: values.iban,
  Bic: values.swiftBic,
  BankAddress: values.bankAddressLine1,
  BankCity: values.bankCity,
  BankCountryCode: values.bankAddressCountryCode,
  BankProvince: values.bankRegion,
  BankPostalCode: values.bankPostalCode,
  BankLocation: values.bankRegion,
  AccountNumber: values.accountNumber,
  NationalBankCode: values.nationalBankCode,
  ThirdParty: values.partyType === 3,
});

export const mapToRemitterUpdateRequest = (values: IRemitterFormValues, entityId: string): components['schemas']['RemitterUpdateRequest'] => ({
  EntityId: entityId,
  Payee: values.remitterName,
  PayeeCountryCode: values.country,
  Currency: values.currency,
  BankName: values.bankName,
  Iban: values.iban,
  Bic: values.swiftBic,
  BankAddress: values.bankAddressLine1,
  BankCity: values.bankCity,
  BankCountryCode: values.bankAddressCountryCode,
  BankProvince: values.bankRegion,
  BankPostalCode: values.bankPostalCode,
  BankLocation: values.bankRegion,
  AccountNumber: values.accountNumber,
  NationalBankCode: values.nationalBankCode,
  ThirdParty: values.partyType === 3,
  Source: 'Platform',
});

export const mapRemitterResponseToFormValues = (values?: components['schemas']['RemitterResponse']): IRemitterFormValues | undefined => {
  if (!values) return undefined;
  return {
    partyType: values.Fields?.ThirdParty?.Value === 'True' ? 3 : 1,
    remitterName: values.Fields?.Payee?.Value ?? '',
    country: values.Fields?.PayeeCountryCode?.Value ?? '',
    currency: values.Fields?.Currency?.Value ?? '',
    bankName: values.Fields?.BankName?.Value ?? '',
    nationalBankCode: values.Fields?.NationalBankCode?.Value ?? '',
    accountNumber: values.Fields?.AccountNumber?.Value ?? '',
    iban: values.Fields?.Iban?.Value ?? '',
    swiftBic: values.Fields?.Bic?.Value ?? '',
    bankAddressCountryCode: values.Fields?.BankCountryCode?.Value ?? '',
    bankAddressLine1: values.Fields?.BankAddress?.Value ?? '',
    bankCity: values.Fields?.BankCity?.Value ?? '',
    bankRegion: values.Fields?.BankProvince?.Value ?? '',
    bankPostalCode: values.Fields?.BankPostalCode?.Value ?? '',
  };
};

export default mapToRemitterCreateRequest;
